export const ERROR_BASES_LIST = 'clientes/baseclientes/error-olas-list';
export const RECEIVE_BASES_LIST = 'clientes/baseclientes/receive-baseclientes-list';
export const REQUEST_BASES_LIST = 'clientes/baseclientes/request-baseclientes-list';
export const RESTART_STATE = 'clientes/baseclientes/restart_state';
export const SET_MASK = 'clientes/baseclientes/set-mask';
export const SET_ORDER = 'clientes/baseclientes/set-order';
export const SET_SELECTED_ROW = 'clientes/baseclientes/set-selected-row';
export const UPDATE_FIELD_FILTER = 'clientes/baseclientes/update-field-filter';
export const UPDATE_TABLE_COLUMN = 'clientes/baseclientes/set-selected-row';